import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"value":_vm.org,"label":_vm.$t('Organisation'),"item-text":"name","item-value":"code","return-object":"","outlined":"","items":_vm.availableOrganisations,"hide-details":"auto"},on:{"input":_vm.onSelect}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }